import { Card, CircularLoader, Icon, Typography } from "@plum-xoxo/admin-dsm";
import React from "react";
import theme from "../../../../theme/theme";
import { isFilterApplied } from "../utils";
import EmptyReportBtn from "./EmptyReportBtn";

const EmptyReports = ({
  loading,
  columns,
  title,
  plumPro,
  hasRecords,
  tableData,
  kyb_status,
  isFirstRewardSent,
}) => {
  let text = "";
  const noFilterApplied = !isFilterApplied(columns);
  if (kyb_status === 2) {
    if (noFilterApplied) {
      if (
        (title === "payments" ||
          title === "invoice payments") &&
        plumPro &&
        hasRecords
      ) {
        text = (
          <>
            There is no transaction history found <br />
            in the last 6 months.
          </>
        );
      } else {
        if (title === "discount store history") {
          text = <>No records found.</>;
        } else if (title === "payments" || title === "invoice payments") {
          text = (
            <>
              Records will be displayed once you <br /> make a transaction using
              your wallet
            </>
          );
        } else {
          text = (
            <>
              Records will be displayed once you <br /> send some rewards
            </>
          );
        }
      }
    } else {
      if (
        (title === "payments" ||
          title === "invoice payments") &&
        plumPro &&
        hasRecords
      ) {
        text =
          "No record found matching the filter criteria in the last 6 months.";
      } else if (!isFirstRewardSent && title !== "payments") {
        text = "Data will be available once you send rewards.";
      } else {
        text = "No records found. Change your filter settings";
      }
    }
  } else {
    text = (
      <>
        Data will be available once you <br />
        send rewards after verifying business details
      </>
    );
  }
  return (
    <Card
      className="box d-flex flex-column justify-content-center align-items-center my-16"
      style={{
        height: "400px",
      }}
    >
      {loading && true ? (
        <>
          <CircularLoader />
          <Typography.Placeholder className="text-center mt-16">
            Reports are getting loaded. Please wait
          </Typography.Placeholder>
        </>
      ) : (
        <>
          {noFilterApplied ? (
            <Icon
              iconName="PlumEmpty"
              color="dark"
              shade="c100"
              fill={theme.palette.dark.c100}
              size={40}
            />
          ) : null}

          <Typography
            className="mt-24 mb-20 text-center"
            color="dark"
            shade="c200"
          >
            {text}
          </Typography>
          {(noFilterApplied || !isFirstRewardSent) &&
            title !== "discount store history" && (
              <EmptyReportBtn
                title={title}
                tableData={tableData}
                kyb_status={kyb_status}
              />
            )}
        </>
      )}
    </Card>
  );
};

export default EmptyReports;
